/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosConfig";

/**
 * Modal para gestionar el ÚNICO recordatorio de un paciente.
 * 
 * Props:
 * - isOpen: boolean
 * - onClose: function
 * - pacienteId: number
 * - pacienteNombre: string
 */
const ModalRecordatoriosPaciente = ({ isOpen, onClose, pacienteId, pacienteNombre }) => {
    const [recordatorio, setRecordatorio] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && pacienteId) {
            fetchRecordatorio();
        }
    }, [isOpen, pacienteId]);

    const fetchRecordatorio = async () => {
        setLoading(true);
        try {
            // Se asume que este endpoint devuelve un objeto con el campo 'observacion'
            // o vacío si no existe.
            const response = await axiosInstance.get(`/paciente/${pacienteId}/recordatorio`);
            if (response.data && response.data.data) {
                setRecordatorio(response.data.data.observacion || "");
            } else {
                setRecordatorio("");
            }
        } catch (error) {
            console.error("Error al cargar recordatorio:", error);
            setRecordatorio("");
        } finally {
            setLoading(false);
        }
    };

    const handleGuardar = async () => {
        try {
            gdAlertify.showLoader();
            // Siempre guardamos/actualizamos el mismo registro para este paciente
            await axiosInstance.post("/paciente/recordatorio/guardar", {
                pacienteId,
                observacion: recordatorio,
            });
            gdAlertify.hideLoader();
            gdAlertify.notify("Recordatorio actualizado.", "success");
            onClose();
        } catch (error) {
            gdAlertify.hideLoader();
            console.error("Error al guardar recordatorio:", error);
            gdAlertify.notify("Error al guardar el recordatorio.", "error");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Recordatorio - {pacienteNombre}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="text-center py-3">Cargando...</div>
                        ) : (
                            <div className="mb-3">
                                <label className="form-label fw-bold">Notas / Recordatorio</label>
                                <textarea
                                    className="form-control"
                                    rows="10"
                                    placeholder="Escribe aquí las notas o recordatorios para este paciente..."
                                    value={recordatorio}
                                    onChange={(e) => setRecordatorio(e.target.value)}
                                ></textarea>
                                <small className="text-muted">
                                    Este campo es único por paciente. Al guardar se sobrescribirá el contenido anterior.
                                </small>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleGuardar}>
                            <i className="bi bi-save me-2"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalRecordatoriosPaciente;
